/**
 * Normalizes a Notion `search` result's `object` field to the kind the picker
 * classifies on.
 *
 * The modern Notion API (2025-09-03+) models a database as having data sources,
 * and `search` returns those data sources as `object: "data_source"` — it no
 * longer emits `object: "database"`. The picker classifies a result as a
 * database via `type === "database"`, so we fold `data_source` into `database`
 * at the single point results are mapped. The database's `id` (the data_source
 * id) still serves as the mindmap's rootPageId.
 *
 * Legacy `object: "database"` is preserved (belt and suspenders) in case an
 * older API version or a cached result is ever seen. Everything else (`page`,
 * unknown, undefined) passes through untouched so nothing is misclassified and
 * a malformed result never crashes the mapper.
 */
export const notionResultType = (object: string | undefined) =>
  object === "data_source" ? "database" : object;
